/**
 * Insert markdown image syntax at a given cursor position in the body text.
 * Adds newlines around the image for clean markdown formatting.
 */
export function insertImageAtCursor(
  body: string,
  cursorPos: number,
  imageUrl: string,
  altText: string,
): string {
  const imageMarkdown = `![${altText}](${imageUrl})`
  const before = body.slice(0, cursorPos)
  const after = body.slice(cursorPos)
  const needsNewlineBefore = before.length > 0 && !before.endsWith('\n')
  const needsNewlineAfter = after.length > 0 && !after.startsWith('\n')
  return before + (needsNewlineBefore ? '\n' : '') + imageMarkdown + (needsNewlineAfter ? '\n' : '') + after
}

/**
 * Replace an existing inline image in markdown body with a new URL and alt text.
 * Escapes special regex characters in the old URL to handle S3 URLs safely.
 */
export function replaceInlineImage(
  body: string,
  oldUrl: string,
  newUrl: string,
  newAlt: string,
): string {
  const escaped = oldUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  return body.replace(new RegExp(`!\\[([^\\]]*)\\]\\(${escaped}\\)`), `![${newAlt}](${newUrl})`)
}
